import { jsx } from "react/jsx-runtime";
import { AdornedInput, Adornment, IconSearch, Input } from "@zillow/constellation";
const PLACEHOLDER_TEXT = "Enter your home address";
const SearchInputWithButton = ({
  _handleAddressSelect,
  _addressSelected,
  _onTagClose,
  _onClear,
  _options,
  ...props
}) => /* @__PURE__ */ jsx(AdornedInput, { input: /* @__PURE__ */ jsx(
  Input,
  {
    id: void 0,
    "data-testid": "address-search-input",
    placeholder: PLACEHOLDER_TEXT,
    ...props
  }
), rightAdornment: /* @__PURE__ */ jsx(Adornment, { "aria-hidden": "false", children: /* @__PURE__ */ jsx(IconSearch, {}) }) });
export {
  PLACEHOLDER_TEXT,
  SearchInputWithButton as default
};
